import React from "react";
import { Controller } from "react-hook-form";
import { Button, Form, Label } from "semantic-ui-react";

export default function ButtonComponent({
  control,
  name,
  label,
  buttonName,
  fieldStyle = "flex-between flex-row-center",
  handleClick,
  error,
  disabled,
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <Form.Field className={fieldStyle}>
            {label ? <label>{label}</label> : <></>}
            <Button
              type="button"
              disabled={disabled ?? false}
              onClick={handleClick}
              {...field}
            >
              {buttonName}
            </Button>
          </Form.Field>
          {error && (
            <Form.Field>
              <Label prompt>{error?.message}</Label>
            </Form.Field>
          )}
        </>
      )}
    />
  );
}
